import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../icon/icon.component';
import {
  defaultContext,
  getInitialStyle,
  getFocusedStyle,
  getUnFocusedStyle,
  ICON_WIDTH,
  PADDING,
  GAP,
} from './facet.style';
import FocusShader from '../shaders/outline.shader';
import { SELECTED_SIGNAL } from '../signals';

export class Facet extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Fill: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Background: {
          shader: {
            type: FocusShader,
          },
        },
        Icon: {
          type: Icon,
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._isLabelTxLoading = false;
    this._minWidth = 0;
    this._focused = false;
    this._selected = false;
    this._textWidth = 0;
  }

  _init() {
    const label = this.tag('Label');

    label.on('txLoaded', () => {
      this._textWidth = label.finalW;
      this._updateSize();
    });
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  _updateSize() {
    if (!this._textWidth) {
      return;
    }

    const { screenSize } = this._style;

    const padding = PADDING[screenSize];
    const closeIconWidth = this._selected ? ICON_WIDTH[screenSize] + GAP[screenSize] : 0;

    this.patch({
      w: padding * 2 + this._textWidth + closeIconWidth,
      Icon: {
        x: padding,
        visible: this._selected,
      },
      Label: {
        x: padding + closeIconWidth,
      },
    });
  }

  get data() {
    return this._data;
  }

  set data(value) {
    if (this._data === value) {
      return;
    }

    this._data = value;
    this.label = value?.title || '';
    this.selected = value?.state === true;
  }

  set label(value) {
    this.tag('Label').text.text = value;
    this._isLabelTxLoading = true;
  }

  get minWidth() {
    return this._minWidth;
  }

  set minWidth(value) {
    this._minWidth = value;
  }

  get selected() {
    return this._selected;
  }

  set selected(value) {
    if (this._selected === value) {
      return;
    }

    if (this._focused) {
      this.patch(getFocusedStyle(this._style, value));
    } else {
      this.patch(getUnFocusedStyle(this._style, value));
    }

    this._selected = value;
    this._updateSize();
  }

  _focus() {
    this._focused = true;
    this.patch(getFocusedStyle(this._style, this._selected));
  }

  _unfocus() {
    this._focused = false;
    this.patch(getUnFocusedStyle(this._style, this._selected));
  }

  _handleEnter() {
    // this.selected = !this.selected;
    this.signal(SELECTED_SIGNAL, this._data);

    return true;
  }
}
